import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AffiliateProgramCommissionsEditModule } from '@modules/affiliate-trackers/submodules/condition/AffiliateTrackersConditionModule';
import { AffiliateTrackersCreativesModule } from '@modules/affiliate-trackers/submodules/creatives/AffiliateTrackersCreativesModule';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  AFFILIATE_TRACKING_LINKS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  AFFILIATE_TRACKERS_LIST_ROUTE_NAME,
  AFFILIATE_TRACKERS_PERMISSIONS,
  AFFILIATE_TRACKERS_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_TRACKERS,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliateTrackersModule extends AppModule {
  protected submodules = [
    new AffiliateProgramCommissionsEditModule(),
    new AffiliateTrackersCreativesModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAffiliateRoute({
      name: AFFILIATE_TRACKERS_ROUTE_NAME,
      path: 'trackers',
      permission: AFFILIATE_TRACKERS_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'AffiliateTrackersListPage',
    });

    router.addChildRoute(AFFILIATE_TRACKERS_ROUTE_NAME, {
      name: AFFILIATE_TRACKERS_LIST_ROUTE_NAME,
      path: '',
      permission: AFFILIATE_TRACKERS_PERMISSIONS.SHOW,
      component: () => import('./pages/AffiliateTrackersListPage/AffiliateTrackersListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAffiliateMenuItem(AFFILIATE_TRACKING_LINKS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'TRACKING_LINKS_TRACKERS'),
      to: {
        name: AFFILIATE_TRACKERS_LIST_ROUTE_NAME,
      },
      permission: AFFILIATE_TRACKERS_PERMISSIONS.SHOW,
      id: AFFILIATE_TRACKERS_LIST_ROUTE_NAME,
      order: 10,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATE_TRACKERS, getTranslationKeys);
  }
}
